import './About.css';

export default function About() {
  return (
    <section className="about" id="about">
      <div className="about-inner">
        <div className="about-text">
          <p className="section-label">About us</p>
          <h2 className="section-title">A mandate to create<br />lasting impact.</h2>
          <div className="divider" />
          <p className="section-body">
            Aranyakam is a private company based in southern India. At its core, it is a bet on rural India's vast economic potential, yet to be unlocked.
          </p>
          <p className="section-body">
            We build and scale rural businesses that offer sustained employment potential, or serve non-urban markets 
            with products and services of superior quality. With capital deployment and deep operational involvement, we ensure that these  
            businesses are adequetely served with proper corporate governance, technology & AI interventions, and strong linkages to global markets.
          </p>
          <p className="section-body" style={{ marginTop: '1rem' }}>
            Our theory of change revolves around decentralized wealth creation. By providing steady employment income to rural youth 
            and women groups, along with crucial benefits such as family health insurance and financial education, our partnerships 
            with ambitious, local entrepreneurs sets up a pathway to long-term wealth creation for rural communities.
          </p>
          
        </div>
        <div className="about-images">
          <div className="about-img-primary">
            <img src="/images/ladies_working.jpg" alt="Workers at Aranyakam facility" />
          </div>
          <div className="about-img-secondary">
            <img src="/images/nursery_5.jpg" alt="Nursery" />
          </div>
        </div>
      </div>
    </section>
  );
}
